import { ReactNode } from 'react';
import { IApiResponse, ITransferBeneficiary } from 'utils/models';

export const sortArrays = [
  'Source Account:',
  'Destination Account:',
  'Beneficiary Name:',
  'Narration:',
  'Transaction Fee:',
  'Transaction Amount:',
  'Total Amount:',
];

export const sortWithScheduleArrays = [
  'Source Account:',
  'Destination Account:',
  'Beneficiary Name:',
  'Narration:',
  'Transaction Fee:',
  'Transaction Amount:',
  'Total Amount:', 'Frequency:', 'Special Date:'];

export const FAB_BANK = { code: '300316', name: 'First Atlantic Bank' };

export interface IExtraFields {
  destinationBankName: string;
  destinationBankCode: string;
  destinationAccountName: string;
  destinationIsExistingBen: boolean;
  beneficiaryId?: number;
  charge?: number;
  destinationCurrency?: string;
}

export interface ITransfersState {
  transferBeneficiaries: ITransferBeneficiary[];
  banks: IBank[];
  isLookingUp?: boolean;
  extras: IExtraFields;
  lastLookedUpAccount: string;
  lastLookedUpBankCode: string;
}

export interface IFormValues {
  sourceAccount: string;
  amount: number | string;
  destinationAccountNo: string;
  narration: string;
  destinationBankCode: string;
  scheduleTransfer?: boolean;
  startDate: string,
  frequency: string,
}

export interface ITransactionField {
  label: ReactNode;
  value: ReactNode;
}

export interface IBank {
  code: string;
  name: string;
}

export interface ITransferResponse extends IApiResponse {
  transactionId: number;
}

export interface IAccountLookup {
  name: string;
  beneficiaryId?: number;
  currency?: string;
}

export interface ILocalLookupRes extends IApiResponse {
  accountName: string;
  accountCurrency?: string;
}

export interface IGetTransferBeneficiaries extends IApiResponse {
  beneficiaries: ITransferBeneficiary[];
}

export interface IGetBankInstitutions extends IApiResponse {
  banks: IBank[];
}

export interface INonInstantBank {
  BankSortCode: string;
  BankName: string;
  BankShortName: string;
}

export type IBanksMappedList = { INSTANT: IBank[]; NON_INSTANT: IBank[] };

export interface IGetNonInstantBanks extends IApiResponse {
  banks: INonInstantBank[];
}

export interface ITransferCharge extends IApiResponse {
  charge: number;
}

export interface ITransferActions {
  getTransactionCharge: (amount: string | number) => void;
  findBeneficiaryName: (values: IFormValues) => void;
  handleSelectBank: (bankCode: string) => void;
}

export type IHandleFieldsChange = () => void;

export interface IElevyState {
  charge: string,
  taxableAmount: string,
  eLevyId: string,
}

export interface IElevyResponse extends IApiResponse {
  charge: string,
  taxableAmount: string,
  eLevyId: string,
}
